import React, { useEffect } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { videoTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import './index.scss';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import ChannelLabel from '@op/components/ChannelLabel';
const videoTypeOptions = (
  formatMessage: ({ id }: { id: string }) => string,
) => [
  {
    text: (
      <span>
        <ChannelLabel
          iconStyle={{ width: 16, height: 16, marginRight: 4 }}
          showText={false}
          channel_name="youtube"
        ></ChannelLabel>
        {formatMessage({ id: 'YouTube shorts' })}
      </span>
    ),
    value: 'youtube',
  },
  {
    text: (
      <span>
        <ChannelLabel
          iconStyle={{ width: 16, height: 16, marginRight: 4 }}
          showText={false}
          channel_name="tiktok"
        ></ChannelLabel>
        {formatMessage({ id: 'TikTok shorts' })}
      </span>
    ),
    value: 'tiktok',
  },
  {
    text: formatMessage({ id: 'Live stream' }),
    value: 'live',
  },
  {
    text: formatMessage({ id: 'Other videos' }),
    value: 'other',
  },
];
export default function VideoTypeSelect({
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const {
    selects: value,
    setSelects: setValue,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'video_types',
    options: videoTypeOptions(formatMessage).map((item) => item.value),
  });
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'video_types',
      commonBackInfo(
        { video_types: value },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [value]);
  return (
    <div className={`video-type-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={videoTypePlaceholder[lang]}
        onClear={() => setValue([])}
        selectOptionsInfo={[value, setValue]}
        options={videoTypeOptions(formatMessage)}
        pointKey={FilterButtonPoint.videoType}
      ></CustomSelect>
    </div>
  );
}
